import { openModal } from '@core/components/ModalStack';
import { TimeMaterialCancelModalProps } from './TimeMaterialCancelModal';

export async function openTimeMaterialCancelModal(props: TimeMaterialCancelModalProps) {
  const { TimeMaterialCancelModal } = await import('./TimeMaterialCancelModal');

  openModal(TimeMaterialCancelModal, props);
}
